import { IDT, usesDesignerContainer } from '@ff-os/pdp-shared-redux/IDT';
import { DisplayMode } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { scrollIntoViewY } from '@ff-os/shared-react/dom/scrollIntoViewY';
import { GiftPdpDispatch } from '@ff-scene-plugins/gift-redux/store';
import { setIsGiftWindowOpen } from './_redux-ui';

export const show = (
    dispatch: GiftPdpDispatch,
    containers: IDT.Containers,
    displayMode: DisplayMode
) => {

    if (usesDesignerContainer(containers) && displayMode === 'inline') {
        scrollIntoViewY(containers.designer, {
            behavior: 'smooth',
            onlyIfNeeded: false
        });
    }

    dispatch(setIsGiftWindowOpen(true));
};